(function($) {

  $.fn.twentytwenty = function(opts) {
    var options = $.extend({
      default_offset_pct: 0.5,
      orientation: 'horizontal',
      before_label: 'Before',
      after_label: 'After',
      no_overlay: false,
      move_slider_on_hover: false,
      move_with_handle_only: true,
      click_to_move: false
    }, opts);

    return this.each(function() {

      // Make sure jquery.event.move is available
      if (!$.event.special.move) {
        console.warn('jquery.event.move.js is not loaded or loaded after twentytwenty.js. Plugin will not function properly.');
        return; 
      }

      var sliderPct         = options.default_offset_pct,
          container         = $(this),
          sliderOrientation = options.orientation,
          beforeDirection   = (sliderOrientation === 'vertical') ? 'down' : 'left',
          afterDirection    = (sliderOrientation === 'vertical') ? 'up'   : 'right';

      container.wrap("<div class='twentytwenty-wrapper twentytwenty-" + sliderOrientation + "'></div>");

      if(!options.no_overlay) {
        container.append("<div class='twentytwenty-overlay'></div>");
        var overlay = container.find(".twentytwenty-overlay");
        overlay.append("<div class='twentytwenty-before-label' data-content='" + options.before_label + "'></div>");
        overlay.append("<div class='twentytwenty-after-label' data-content='" + options.after_label + "'></div>");
      }

      var beforeImg = container.find("img:first"),
          afterImg  = container.find("img:last");

      container.append("<div class='twentytwenty-handle'></div>");

      var slider = container.find(".twentytwenty-handle");
      slider.append("<span class='twentytwenty-" + beforeDirection + "-arrow'></span>");
      slider.append("<span class='twentytwenty-" + afterDirection + "-arrow'></span>");

      container.addClass("twentytwenty-container");
      beforeImg.addClass("twentytwenty-before");
      afterImg.addClass("twentytwenty-after");

      var beforeLabel = container.find('.twentytwenty-before-label'),
          afterLabel  = container.find('.twentytwenty-after-label');

      function calcOffset(dimensionPct) {
        var w  = beforeImg.width(),
            h  = beforeImg.height();
        return {
          w:  w + "px",
          h:  h + "px",
          cw: (dimensionPct * w) + "px",
          ch: (dimensionPct * h) + "px"
        };
      }

      function adjustContainer(offset) {
        if (sliderOrientation === 'vertical') {
          beforeImg.css("clip", "rect(0," + offset.w + "," + offset.ch + ",0)");
          afterImg.css("clip",  "rect(" + offset.ch + "," + offset.w + "," + offset.h + ",0)");
        } else {
          beforeImg.css("clip", "rect(0," + offset.cw + "," + offset.h + ",0)");
          afterImg.css("clip",  "rect(0," + offset.w  + "," + offset.h + "," + offset.cw + ")");
        }
        container.css("height", offset.h);
      }

      function adjustSlider(pct) {
        var offset = calcOffset(pct);
        if (sliderOrientation === 'vertical') {
          slider.css("top", offset.ch);
        } else {
          slider.css("left", offset.cw);
        }
        adjustContainer(offset);
      }

      function minMaxNumber(num, min, max) {
        return Math.max(min, Math.min(max, num));
      }

      function getSliderPercentage(positionX, positionY, offsetX, offsetY, imgWidth, imgHeight) {
        if (sliderOrientation === 'vertical') {
          return minMaxNumber((positionY - offsetY) / imgHeight, 0, 1);
        } else {
          return minMaxNumber((positionX - offsetX) / imgWidth, 0, 1);
        }
      }

      $(window).on("resize.twentytwenty", function() {
        adjustSlider(sliderPct);
      });

      var offsetX = 0,
          offsetY = 0,
          imgWidth = 0,
          imgHeight = 0;

      function onMoveStart(e) {
        // These distX/distY checks rely on jquery.event.move
        if (((e.distX > e.distY && e.distX < -e.distY) ||
             (e.distX < e.distY && e.distX > -e.distY)) && sliderOrientation !== 'vertical') {
          e.preventDefault();
        } else if (((e.distX < e.distY && e.distX < -e.distY) ||
                    (e.distX > e.distY && e.distX > -e.distY)) && sliderOrientation === 'vertical') {
          e.preventDefault();
        }
        container.addClass("active");
        offsetX   = container.offset().left;
        offsetY   = container.offset().top;
        imgWidth  = beforeImg.width();
        imgHeight = beforeImg.height();
      }

      function onMove(e) {
        if (container.hasClass("active")) {
          sliderPct = getSliderPercentage(e.pageX, e.pageY, offsetX, offsetY, imgWidth, imgHeight);
          adjustSlider(sliderPct);
        }
      }

      function onMoveEnd() {
        container.removeClass("active");
      }

      var moveTarget = options.move_with_handle_only ? slider : container;
      
      // Only attach the move events if jquery.event.move is present
      moveTarget.on("movestart", onMoveStart);
      moveTarget.on("move", onMove);
      moveTarget.on("moveend", onMoveEnd);

      if (options.move_slider_on_hover) {
        container.on("mouseenter", onMoveStart);
        container.on("mousemove", onMove);
        container.on("mouseleave", onMoveEnd);
      }

      slider.on("touchmove", function(e) {
        e.preventDefault();
      });

      container.find("img").on("mousedown", function(event) {
        event.preventDefault();
      });

      if (options.click_to_move) {
        container.on('click', function(e) {
          offsetX   = container.offset().left;
          offsetY   = container.offset().top;
          imgWidth  = beforeImg.width();
          imgHeight = beforeImg.height();
          sliderPct = getSliderPercentage(e.pageX, e.pageY, offsetX, offsetY, imgWidth, imgHeight);
          adjustSlider(sliderPct);
        });
      }

      // Initialize
      $(window).trigger("resize.twentytwenty");
    });
  };

})(jQuery);